"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileToString = void 0;
var exhaustive_check_1 = require("../utils/exhaustive-check");
function compileToString(e) {
    var funcstr = makeJSExprForBooleanExpr(e);
    // console.log("funcstr", funcstr);
    // eslint-disable-next-line no-new-func
    var func = new Function("p", "return " + funcstr);
    return func;
}
exports.compileToString = compileToString;
function makeJSExprForBooleanExpr(e) {
    var jsExpression = (function () {
        switch (e.type) {
            case "AndExpr": {
                var mystr = "";
                for (var _i = 0, _a = e.children; _i < _a.length; _i++) {
                    var child = _a[_i];
                    mystr += " && " + makeJSExprForBooleanExpr(child);
                }
                return mystr.length ? mystr.substr(4) : mystr;
            }
            case "OrExpr": {
                var mystr = "";
                for (var _b = 0, _c = e.children; _b < _c.length; _b++) {
                    var child = _c[_b];
                    mystr += " || " + makeJSExprForBooleanExpr(child);
                }
                return mystr.length ? mystr.substr(4) : mystr;
            }
            case "EqualsExpr": {
                var mystr = "";
                var singleOrCount = 0;
                var left = makeJsExprForPropertyValueExpr(e.leftValue);
                for (var _d = 0, _e = e.rightValueRanges; _d < _e.length; _d++) {
                    var range = _e[_d];
                    var min = makeJsExprForPropertyValueExpr(range.min);
                    var max = makeJsExprForPropertyValueExpr(range.max);
                    if (min === max) {
                        singleOrCount++;
                        if (e.operationType === "equals") {
                            mystr += " || " + left + " === " + max;
                        }
                        else {
                            mystr += " && " + left + " !== " + max;
                        }
                    }
                    else if (e.operationType === "equals") {
                        mystr += " || (" + left + " >= " + min + " && " + left + " <= " + max + ")";
                    }
                    else {
                        mystr += " && (" + left + " < " + min + " || " + left + " > " + max + ")";
                    }
                }
                return mystr.length ? (singleOrCount > 1 ? "(" + mystr.substr(4) + ")" : mystr.substr(4)) : mystr;
            }
            case "ComparisonExpr": {
                var left = makeJsExprForPropertyValueExpr(e.leftValue);
                if (left === "null") {
                    return " false ";
                }
                var right = makeJsExprForPropertyValueExpr(e.rightValue);
                if (right === "null") {
                    return " false ";
                }
                switch (e.operationType) {
                    case "less":
                        return left + " < " + right;
                    case "greater":
                        return left + " > " + right;
                    case "lessOrEqual":
                        return left + " <= " + right;
                    case "greaterOrEqual":
                        return left + " >= " + right;
                    default:
                        return exhaustive_check_1.exhaustiveCheck(e, true);
                }
            }
            case "EmptyExpr": {
                return " true ";
            }
            default: {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return exhaustive_check_1.exhaustiveCheck(e, true, e.type);
            }
        }
    })();
    return jsExpression === "" ? jsExpression : "(" + jsExpression + ")";
}
// Returns something that evaluates to a PropertyValue or null
function makeJsExprForPropertyValueExpr(e) {
    switch (e.type) {
        case "IdentifierExpr": {
            return "(p['" + e.name + "'] && p['" + e.name + "'].value)";
        }
        case "ValueExpr": {
            if (e.parsed.type !== "integer") {
                throw new Error("PropertyFilter with non integer value cannot be compiled.");
            }
            return e.parsed.value.toString();
        }
        case "NullExpr": {
            return "undefined";
        }
        case "AddExpr": {
            var left = makeJsExprForPropertyValueExpr(e.left);
            var right = makeJsExprForPropertyValueExpr(e.right);
            switch (e.operationType) {
                case "add":
                    return left + " + " + right;
                case "subtract":
                    return left + " - " + right;
                default:
                    return exhaustive_check_1.exhaustiveCheck(e, true);
            }
        }
        case "MulExpr": {
            var left = makeJsExprForPropertyValueExpr(e.left);
            var right = makeJsExprForPropertyValueExpr(e.right);
            switch (e.operationType) {
                case "multiply":
                    return left + " * " + right;
                case "divide":
                    return left + " / " + right;
                default:
                    return exhaustive_check_1.exhaustiveCheck(e, true);
            }
        }
        case "UnaryExpr": {
            var value = makeJsExprForPropertyValueExpr(e.value);
            return "-" + value;
        }
        default: {
            return exhaustive_check_1.exhaustiveCheck(e, true);
        }
    }
}
//# sourceMappingURL=compile-to-string.js.map